import React from 'react'

export default function Convert(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="var(--icon-muted, #747894)" {...props}>
    <path d="M3.5 8.5h15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 5l3.5 3.5L15 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20.5 15.5h-15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 12l-3.5 3.5L9 19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
